/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteDocumentById } from '../fn/document-controller-v-2/delete-document-by-id';
import { DeleteDocumentById$Params } from '../fn/document-controller-v-2/delete-document-by-id';
import { DocumentContentDto } from '../models/document-content-dto';
import { DocumentMetaDataDto } from '../models/document-meta-data-dto';
import { getDocumentContentById } from '../fn/document-controller-v-2/get-document-content-by-id';
import { GetDocumentContentById$Params } from '../fn/document-controller-v-2/get-document-content-by-id';
import { getDocumentMetadataById } from '../fn/document-controller-v-2/get-document-metadata-by-id';
import { GetDocumentMetadataById$Params } from '../fn/document-controller-v-2/get-document-metadata-by-id';
import { updateDocument } from '../fn/document-controller-v-2/update-document';
import { UpdateDocument$Params } from '../fn/document-controller-v-2/update-document';

@Injectable({ providedIn: 'root' })
export class DocumentControllerV2Api extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDocumentMetadataById()` */
  static readonly GetDocumentMetadataByIdPath = '/v2/documents/{idDocument}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocumentMetadataById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentMetadataById$Response(
    params: GetDocumentMetadataById$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<DocumentMetaDataDto>> {
    return getDocumentMetadataById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDocumentMetadataById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentMetadataById(
    params: GetDocumentMetadataById$Params,
    context?: HttpContext
  ): Observable<DocumentMetaDataDto> {
    return this.getDocumentMetadataById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentMetaDataDto>): DocumentMetaDataDto => r.body)
    );
  }

  /** Path part for operation `updateDocument()` */
  static readonly UpdateDocumentPath = '/v2/documents/{idDocument}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDocument$Response(
    params: UpdateDocument$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDocument(params: UpdateDocument$Params, context?: HttpContext): Observable<string> {
    return this.updateDocument$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `deleteDocumentById()` */
  static readonly DeleteDocumentByIdPath = '/v2/documents/{idDocument}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDocumentById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDocumentById$Response(
    params: DeleteDocumentById$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<{}>> {
    return deleteDocumentById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDocumentById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDocumentById(params: DeleteDocumentById$Params, context?: HttpContext): Observable<{}> {
    return this.deleteDocumentById$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `getDocumentContentById()` */
  static readonly GetDocumentContentByIdPath = '/v2/documents/{idDocument}/contenu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocumentContentById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentContentById$Response(
    params: GetDocumentContentById$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<DocumentContentDto>> {
    return getDocumentContentById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDocumentContentById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentContentById(params: GetDocumentContentById$Params, context?: HttpContext): Observable<DocumentContentDto> {
    return this.getDocumentContentById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentContentDto>): DocumentContentDto => r.body)
    );
  }
}
